import * as Sentry from '@sentry/browser';
import { SENTRY_IGNORE_URLS, filterNoiseFetchCall } from './utils/breadcrumb';

const CDS_SENTRY_DSN =
  'https://280699ec880c4959b534df9e059a5fe4@o314552.ingest.us.sentry.io/4504075322654720';

const environment =
  process.env['REACT_APP_LOGGING_ENV'] || process.env.NODE_ENV || 'development';

if (!['local', 'development'].includes(environment)) {
  Sentry.init({
    denyUrls: SENTRY_IGNORE_URLS,
    dsn: CDS_SENTRY_DSN,
    environment: environment,
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    replaysOnErrorSampleRate: 1,
    replaysSessionSampleRate: 0,
    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: false,
        dom: {
          serializeAttribute: ['data-testid', 'textContent'],
        },
      }),
      Sentry.httpClientIntegration(),
      Sentry.inboundFiltersIntegration({
        ignoreErrors: [
          'Failed to fetch',
          'Network request failed',
          'AbortError',
          'Load failed',
          "Failed to execute 'readText' on 'Clipboard'",
        ],
      }),
    ],
    beforeBreadcrumb: breadcrumb => {
      return filterNoiseFetchCall(breadcrumb);
    },
  });
}

export default Sentry;
